import { io } from 'socket.io-client';

export const socket = io('https://pacman.fantasyworldtrpg.cz:3001', {
    autoConnect: false,
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
});
